import { isArray } from 'lodash';

export const serializeDeparture = departure => ({
  id: departure.id,
  name: departure.name,
});

export const serializeDepartures = departures => {
  if (!isArray(departures) && departures.length < 1) return null;

  return departures.map(departure => serializeDeparture(departure));
};
